import styled from "styled-components";
import { ButtonCommon } from "../../../Layout/styled";

export const CampaignContainer = styled.div``;
export const CampaignWrapper = styled.div`
  max-width: 1201px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  .campaign-inner {
    display: flex;
    align-items: flex-start;
    gap: 80px;
  }
  @media screen and (max-width: 768px) {
    width: unset;
    .campaign-inner {
      display: block;
      padding-bottom: 100px;
    }
  }
`;
export const CampaignLeft = styled.div`
  max-width: 70%;
  width: 100%;
  .block-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 48px;
    ${ButtonCommon} {
      width: 105px;
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 12px;
      font-weight: 500;
      padding-top: 11px;
      padding-bottom: 7px;
      img {
        position: relative;
        top: -1px;
      }
    }
  }
  .heading-image {
    width: 100px;
    height: 100px;
    border-radius: 100px;
    border: 1px solid var(--Neutral-300, #b8b8c1);
  }
  .heading-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .title-heading {
    color: var(--Neutral-50, #f7f7f8);
    font-family: Syne;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 30px */
    margin-bottom: 6px;
  }
  .people {
    color: var(--Neutral-50, #f7f7f8);
    font-family: DMMono-500;
    font-size: 14px;
    font-style: normal;
    line-height: 125%; /* 17.5px */
    margin-right: 4px;
  }
  .part {
    color: var(--Neutral-400, #92929e);
    font-family: Syne;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 15px */
  }
  .title-detail {
    color: var(--Neutral-50, #f7f7f8);
    font-family: Dirtyline;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 96%; /* 23.04px */
    text-transform: lowercase;
    margin-bottom: 21px;
  }
  .list-tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 48px;
    li {
      border-radius: 7.01px;
      border: 1px solid var(--Neutral-700, #4d4d57);
      background: rgba(40, 39, 44, 0.6);
      padding: 4px 16px;
      color: var(--Neutral-50, #f7f7f8);
      font-family: Syne;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
    }
  }
  .block-swap {
    border-radius: 12px;
    border: 1px solid var(--Neutral-300, #b8b8c1);
    background: #1c1c1e;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 48px;
    p {
      font-family: Dirtyline;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 133.333% */
      text-transform: lowercase;
      background: linear-gradient(
        90deg,
        #ff3556 0%,
        #ff63a1 25%,
        #ffdb87 50%,
        #fff 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    ${ButtonCommon} {
      width: 111px;
      font-size: 12px;
      font-weight: 500;
    }
  }
  .block-desc {
    margin-bottom: 48px;
    h3 {
      color: var(--Neutral-50, #f7f7f8);
      font-family: Dirtyline;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 96%; /* 23.04px */
      text-transform: lowercase;
      margin-bottom: 16px;
    }
    p {
      color: var(--Neutral-100, #eeeef0);
      font-family: Syne;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px; /* 137.5% */
      &:not(:last-child) {
        margin-bottom: 12px;
      }
    }
  }
  .block-suggest {
    h3 {
      color: var(--Neutral-50, #f7f7f8);
      font-family: Dirtyline;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 96%; /* 23.04px */
      text-transform: lowercase;
      margin-bottom: 16px;
    }
    .block-campaign {
      display: flex;
      align-items: center;
      gap: 16px;
      .item-campaign {
        width: calc(100% / 2 - 16px);
      }
    }
  }
  &.light {
    .title-heading {
      color: var(--Red-950, #430c0c);
    }
    .people {
      color: var(--Neutral-800, #43424a);
    }
    .part {
      color: var(--Neutral-400, #92929e);
    }
    .more {
      background: #43424a;
      color: #fff;
    }
    .title-detail {
      color: var(--Neutral-900, #3a3a40);
    }
    .list-tags {
      li {
        border: 1px solid var(--Neutral-300, #b8b8c1);
        background: var(--Neutral-100, #eeeef0);
        color: var(--Neutral-700, #4d4d57);
      }
    }
    .block-swap {
      border: 1px solid var(--Neutral-400, #92929e);
      background: #fff;
      p {
        background: linear-gradient(
          90deg,
          #ff3556 0%,
          #ff63a1 36.42%,
          #ffdb87 101.97%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .block-desc {
      h3 {
        color: var(--Neutral-800, #43424a);
      }
      p {
        color: var(--Neutral-700, #4d4d57);
      }
    }
    .block-suggest {
      h3 {
        color: var(--Neutral-800, #43424a);
      }
    }
  }
  @media screen and (max-width: 768px) {
    max-width: unset;
    .heading-image {
      width: 50px;
      height: 50px;
    }
    .title-heading {
      font-size: 18px;
    }
    .block-heading {
      ${ButtonCommon} {
        width: 85px;
      }
    }
    .block-suggest {
      .block-campaign {
        display: block;
        .item-campaign {
          width: auto;
          &:not(:last-child) {
            margin-bottom: 24px;
          }
        }
      }
    }
  }
`;

export const CampaignRight = styled.div`
  max-width: 30%;
  width: 100%;
  .title-rewards {
    color: var(--Neutral-50, #f7f7f8);
    font-family: Dirtyline;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 96%; /* 23.04px */
    text-transform: lowercase;
    margin-bottom: 12px;
  }
  .detail-rewards {
    border-radius: 25.362px;
    border: 0.5px solid rgba(255, 255, 255, 0.25);
    background: #0e0e0e;
    padding: 24px 48px;
    text-align: center;
    position: relative;
    overflow: hidden;
    margin-bottom: 48px;
    &:before {
      position: absolute;
      content: "";
      left: -393.894px;
      top: -166.223px;
      width: 438.001px;
      height: 478.838px;
      transform: rotate(-150.635deg);
      border-radius: 478.838px;
      opacity: 0.87;
      background: linear-gradient(
        190deg,
        #cfd0da 34.26%,
        rgba(207, 208, 218, 0) 92.38%
      );
      filter: blur(146.88499450683594px);
      pointer-events: none;
    }
  }
  .title-detail {
    color: var(--Neutral-50, #f7f7f8);
    font-family: Dirtyline;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 96%; /* 23.04px */
    text-transform: lowercase;
    margin-bottom: 24px;
    text-align: center;
  }
  .image-swap {
    margin-bottom: 24px;
  }
  .point {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.75);
    text-align: center;
    font-size: 12.681px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 15.851px */
    margin-bottom: 12px;
    span {
      margin-left: 8px;
      color: var(--New, #e84142);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 14px; /* 100% */
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
  .chain {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--Neutral-100, #eeeef0);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px; /* 100% */
    border-radius: 4px;
    background: var(--Neutral-800, #43424a);
    padding: 4px;
    width: 97px;
    margin: 0 auto;
  }
  .block-user {
    .title-user {
      color: var(--Neutral-50, #f7f7f8);
      font-family: Dirtyline;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 96%; /* 23.04px */
      text-transform: lowercase;
      margin-bottom: 16px;
    }
  }
  .list-user {
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:not(:last-child) {
        margin-bottom: 12px;
      }
    }
  }
  .user-left {
    display: flex;
    align-items: center;
    gap: 11px;
  }
  .name {
    color: var(--Neutral-100, #eeeef0);
    font-family: Syne;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 137.5% */
  }
  .time {
    color: var(--Neutral-400, #92929e);
    font-family: Syne;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 137.5% */
  }
  .user-point {
    color: var(--Neutral-50, #f7f7f8);
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    border-radius: 7.01px;
    background: rgba(40, 39, 44, 0.6);
    padding: 9px 15px;
  }
  &.light {
    .title-rewards {
      color: var(--Neutral-900, #3a3a40);
    }
    .detail-rewards {
      border: 1px solid var(--Neutral-300, #b8b8c1);
      background: #eeeef0;
    }
    .title-detail {
      color: var(--Neutral-900, #3a3a40);
    }
    .point {
      color: var(--Neutral-500, #6e6e7c);
      span {
        color: var(--New, #e84142);
      }
    }
    .chain {
      background: var(--Neutral-50, #f7f7f8);
      color: var(--Neutral-800, #43424a);
    }
    .block-user {
      .title-user {
        color: var(--Neutral-900, #3a3a40);
      }
    }
    .name {
      color: var(--Neutral-800, #43424a);
    }
    .time {
      color: var(--Neutral-400, #92929e);
    }
    .user-point {
      background: #f6f6f6;
      color: var(--Neutral-700, #4d4d57);
    }
  }
  @media screen and (max-width: 768px) {
    max-width: unset;
  }
`;

export const BlockToken = styled.div`
  display: flex;
  align-items: center;
  .token-inner {
    display: flex;
    align-items: center;
    margin-right: 8px;
    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      object-fit: cover;
      &:not(:first-child) {
        margin-left: -8px;
      }
    }
  }
  .more {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    border: 0.64px solid #000;
    background: #fff;
    color: #000;
    font-size: 12.8px;
    font-family: DMMono-500;
    line-height: 120%; /* 15.36px */
    letter-spacing: -0.256px;
    margin-left: -8px;
  }
  @media screen and (max-width: 768px) {
    .token-inner {
      img {
        width: 18px;
        height: 18px;
      }
    }
    .more {
      width: 16px;
      height: 16px;
      font-size: 7px;
    }
  }
`;
